/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import axios from 'axios';
import { post } from '../../axios';
import {Col,Row, Form, Icon, Dropdown,Carousel,Menu ,Popover} from 'antd';
import { connect } from 'react-redux';
import {Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { fetchData, receiveData } from '@/action';
import BannerAnim, { Element } from 'rc-banner-anim';
import TweenOne from 'rc-tween-one';
import 'rc-banner-anim/assets/index.css';


import banner from '@/style/imgs/bizhengImg/bizhengBanner.png';
import main1 from '@/style/imgs/bizhengImg/main1.png';
import main2 from '@/style/imgs/bizhengImg/main2.png';
import main3 from '@/style/imgs/bizhengImg/main3.png';
import main4 from '@/style/imgs/bizhengImg/main4.png';
import kehu from '@/style/imgs/bizhengImg/kehu.png';
import footer from '@/style/imgs/bizhengImg/footer.png';

import ptrkbanner from '@/style/imgs/all/ptrkbanner.png';
import amount from '@/style/imgs/all/amount.png';
import zzpa from '@/style/imgs/all/zzpa.png';
import zzrs from '@/style/imgs/all/zzrs.png';
import acbx from '@/style/imgs/all/acbx.png';
import astp from '@/style/imgs/all/astp.png';
import phone from '@/style/imgs/all/phone.png';
import phone1 from '@/style/imgs/all/phone1.png';
import wx from '@/style/imgs/all/wx.png';
import wx1 from '@/style/imgs/all/wx1.png';
import xcx from '@/style/imgs/all/xcx.png';
import xcx1 from '@/style/imgs/all/xcx1.png';
import tel from '@/style/imgs/all/tel.png';
import tel1 from '@/style/imgs/all/tel1.png';
import lb from '@/style/imgs/all/lb.png';
import rb from '@/style/imgs/all/rb.png';
import logo from '@/style/imgs/bizhengImg/logo.png';
import fw from '@/style/imgs/all/fw.png';
import rmbx from '@/style/imgs/all/rmbx.png';
import tpy from '@/style/imgs/all/tpy.png';
import zybx from '@/style/imgs/all/zybx.png';
import bc from '@/style/imgs/all/bc.png';
import bm from '@/style/imgs/all/bm.png';
import jljt from '@/style/imgs/all/jljt.png';
import cdd from '@/style/imgs/all/cdd.png';
import imgB from '@/style/imgs/all/imgB.png';
import ydjyewm from '@/style/imgs/all/yidian.png';
import feimaewm from '@/style/imgs/all/feima.png';
import xcxewm from '@/style/imgs/all/xcxewm.png';

const FormItem = Form.Item;
const BgElement = Element.BgElement;
const MenuItemGroup = Menu.ItemGroup;
const SubMenu = Menu.SubMenu;

class LoginCopy extends React.Component {
    state = {
        active:1,
        orderActive:"",
        title:"",
        index:0,
        bannerIndex:1,
        current:"login",
        showButton:true,
        imgList:[
            {src:"tc",img:require("@/style/imgs/all/tc.png"),title:"拖车救援"},
            {src:"dd",img:require("@/style/imgs/all/dd.png"),title:"搭电"},
            {src:"ht",img:require("@/style/imgs/all/ht.png"),title:"换胎"},
            {src:"sy",img:require("@/style/imgs/all/sy.png"),title:"送油"},
            {src:"ss",img:require("@/style/imgs/all/ss.png"),title:"送水"},
            {src:"ys",img:require("@/style/imgs/all/ys.png"),title:"钥匙"},
        ],
        imgListUse:[
            {src:"tc",img:require("@/style/imgs/all/tc.png"),title:"拖车救援"},
            {src:"dd",img:require("@/style/imgs/all/dd.png"),title:"搭电"},
            {src:"ht",img:require("@/style/imgs/all/ht.png"),title:"换胎"},
            {src:"sy",img:require("@/style/imgs/all/sy.png"),title:"送油"},
        ]
    };
    componentDidMount() {

    };
    componentWillMount() {
        const { receiveData } = this.props;
        receiveData(null, 'auth');
    }
    changeActive = (name) =>{
        const { history } = this.props;
        history.push("/feima/"+name)
    }
    turnlogin =()=>{
        const { history } = this.props;
        window.open("http://hd.feima666.com");
    }
    prevImg =()=>{
        if(this.state.index==2){
            let imgArry=this.state.imgListUse;
            imgArry.pop();
            imgArry.unshift(this.state.imgList[1])
            this.setState({
                imgListUse:imgArry,
                index:1
            })
        }else if(this.state.index==1){
            let imgArry=this.state.imgListUse;
            imgArry.pop();
            imgArry.unshift(this.state.imgList[0])
            this.setState({
                imgListUse:imgArry,
                index:0
            })
        }
    }
    nextImg =()=>{
        if(this.state.index==0){
            let imgArry=this.state.imgListUse;
            imgArry.shift();
            imgArry.push(this.state.imgList[4])
            this.setState({
                imgListUse:imgArry,
                index:1
            })
        }else if(this.state.index==1){
            let imgArry=this.state.imgListUse;
            imgArry.shift();
            imgArry.push(this.state.imgList[5])
            this.setState({
                imgListUse:imgArry,
                index:2
            })
        }
    }
    toggleHover =(e)=>{
        e.target.src=require("@/style/imgs/all/lb.png")
    }
    toggleLeave=(e)=>{
        e.target.src=require("@/style/imgs/all/rb.png")
    }
    appOver =(type)=>{
            let stateObj = {};
            stateObj[type]=true;
            this.setState(stateObj);
    }
    appOut =(type)=>{
        let stateObj = {};
        stateObj[type]=false;
        this.setState(stateObj);
    }
    imgChange = (from, to) =>{
        if(from==2){
            this.setState({
                showButton:true,
            })
        }else{
            this.setState({
                showButton:false,
            })
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div style={{overflowY:"auto",width:"1912px"}}>
                <Col style={{height:86,background:"#333",overflow:"hidden"}}>
                    <Row>
                        <Col span={7}>
                            <img style={{marginTop:15,marginLeft:200}} src={logo} alt=""/>
                          
                        </Col>
                        <Col span={17}>
                                <Row style={{width:800,color:"#fff",fontSize:16,paddingTop:39}}>
                                    <Col span={4}>首页</Col>     
                                    <Col span={4}>关于我们</Col>     
                                    <Col span={4}>服务介绍</Col>     
                                    <Col span={4}>公司新闻</Col>     
                                    <Col span={4}>发展策略</Col>     
                                    <Col span={4}>联系我们</Col>     
                            </Row>   
                        </Col>
                    </Row>
                  
                   
                </Col>
                <Col>
                    <Col style={{height:720,position:"relative"}}>
                        <div style={{position:"relative"}}>
                            <img style={{width:"100%"}} src={banner} alt=""/>
                        </div>
                    </Col>
                    <Col style={{textAlign:"center"}}>
                        <Col style={{marginTop:68,fontSize:"30px",color:"#212121",fontWeight:"bold"}}>我们的服务</Col>
                        <Col style={{marginTop:18,fontSize:"16px",color:"#666666"}}>our services </Col>
                     
                    </Col>
                    <Row style={{marginTop:20}}>
                        <Col offset={4} span={4}>
                            <img src={main1} alt=""/>
                        </Col>
                        <Col span={4}>
                        <img src={main2} alt=""/>
                        </Col>
                        <Col span={4}>
                        <img src={main3} alt=""/>
                        </Col>
                        <Col  span={4}>
                        <img src={main4} alt=""/>
                        </Col>
                       
                    </Row>
                    <Col style={{textAlign:"center"}}>
                        <img src={kehu} alt=""/>
                    </Col>
                
               
                </Col>
                <div style={{marginTop:50,overflow:"hidden",textAlign:"center",background:"rgba(44, 44, 44, 1)"}}>
                        <img src={footer} alt=""/>
                        
                    <Col style={{clear:"both"}}></Col>
                    <Col style={{lineHeight:"44px",height:44,fontSize:14,textAlign:"center",background:"#333",marginTop:30,color:"#fff"}}>Copyright©2016-2021 hangzhoubizheng.com 版权所有</Col>

                </div>
            </div>


        );
    }
}

const mapStateToPorps = state => {
    const { auth } = state.httpData;
    return { auth };
};
const mapDispatchToProps = dispatch => ({
    fetchData: bindActionCreators(fetchData, dispatch),
    receiveData: bindActionCreators(receiveData, dispatch)
});


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(LoginCopy));


// WEBPACK FOOTER //
// ./src/components/pages/LoginCopy.jsx